<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Details"
            bc1="App"
            bc2="Privilege"
            bc3="Update"
            path="privilege"
          ></Breadcrumb>
        </div>

      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div>
                      <div>
                        <div class="col-sm-9 offset-sm-3 text-right mt-2"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Currency Payment Method </label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-select
                                v-model="currencyPaymentMethodId"
                                size="sm"
                                class="mt-1"
                              >
                                <b-form-select-option
                                  :value="item.id"
                                  v-for="(item, index) in requestCurrencyPaymentData"
                                  :key="index"
                                  >{{ item.payment_method.name }}
                                </b-form-select-option>
                              </b-form-select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Transaction Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-select
                                v-model="transactionTypeId"
                                size="sm"
                                class="mt-1"
                              >
                                <b-form-select-option
                                  :value="item.id"
                                  v-for="(item, index) in transactionTypeRequestData"
                                  :key="index"
                                  >{{ item.name }}
                                </b-form-select-option>
                              </b-form-select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">minLimit</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="minLimit"
                                class="form-control"
                                :class="
                                  errorBag.has('minLimit') ? 'is-invalid' : ''
                                "
                                name="minLimit"
                                placeholder="Min Limit"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('minLimit')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("minLimit") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Max Limit</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="maxLimit"
                                class="form-control"
                                :class="
                                  errorBag.has('maxLimit') ? 'is-invalid' : ''
                                "
                                name="maxLimit"
                                placeholder="Max Limit"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('maxLimit')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("maxLimit") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Foreign Charge</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="foreignCharge"
                                class="form-control"
                                :class="
                                  errorBag.has('foreignCharge')
                                    ? 'is-invalid'
                                    : ''
                                "
                                name="foreignCharge"
                                placeholder="Foreign Charge"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('foreignCharge')"
                                class="invalid-feedback"
                                >{{
                                  "*" + errorBag.first("foreignCharge")
                                }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Processing Time</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="processingTime"
                                class="form-control"
                                :class="
                                  errorBag.has('processingTime')
                                    ? 'is-invalid'
                                    : ''
                                "
                                name="processingTime"
                                placeholder="Processing Time"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('processingTime')"
                                class="invalid-feedback"
                                >{{
                                  "*" + errorBag.first("processingTime")
                                }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-9 off-sm-3 text-right mt-2 d-flex">
                      <button
                        type="button"
                        class="btn btn-primary mr-1 d-flex"
                        @click="sendCall"
                        :disabled="loading"
                      >
                        <Loader :loading="loading" :size="size"></Loader>
                        Submit
                      </button>
                      <button
                        type="button"
                        class="btn btn-gradient-secondary"
                        @click="$router.push({ name: 'privilege' })"
                      >
                        Back
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import { mapGetters } from "vuex";

export default {
  components: {
    CommandIcon
  },
  data() {
    return {
      transactionTypeRequestData: [],
      requestCurrencyPaymentData : [],
      id: "",
      vpPercentageCharges: "",
      vpFixedCharges: "",
      currencyPaymentMethodId: "",
      transactionTypeId: "",
      PaymentMethodName: "",
      currencyName: "",
      gwPercentageCharges: "",
      gwFixedCharges: "",
      otherCharges: "",
      minLimit: "",
      maxLimit: "",
      foreignCharge: "",
      otherChargesType: "",
      processingTime: "",
      transactionData: [],
      currencyPaymentMethodData: [],
      loading: false,
      size: "10px"
    };
  },
  computed: {
    ...mapGetters({
      PrivilegeSelectData: "getByKey"
    })
  },
  created() {
    this.makeRequest("post", "v1/transaction-types", {
      flag: "active"
    },{},false).then(callResponse => {
      if (!callResponse.error) {
        let code = callResponse.response.data.code;
        // let data = callResponse.response.data.data;
        // data.key = "privilegeTransactionTypeSelect";
        if (code == 200) {
          let data = [];
          data = callResponse.response.data.data;
          this.transactionTypeRequestData = data
          // this.$store.dispatch("set", data);
        }
      }
    });
    this.makeRequest("post", "v1/get-currency-payment-method", {
      flag: "active"
    },{},false).then(callResponse => {
      if (!callResponse.error) {
        let code = callResponse.response.data.code;
        // let data = callResponse.response.data.data;
        // data.key = "privilegeUpdateCurrencyPaymentSelect";
        if (code == 200) {
          let data = [];
          data = callResponse.response.data.data;
          this.requestCurrencyPaymentData = data
          // this.$store.dispatch("set", data);
        }
      }
    });
  },
  mounted() {
    let privilegeUpdateData = this.$store.getters.getByKey("privilegeUpdate");
    this.index = privilegeUpdateData.index;
    this.id = privilegeUpdateData.row.id;
    this.currencyPaymentMethodId =
      privilegeUpdateData.row.currency_payment_method_id;
    this.transactionData = privilegeUpdateData.row.transaction_type;
    this.minLimit = privilegeUpdateData.row.min_limit / 100;
    this.maxLimit = privilegeUpdateData.row.max_limit / 100;
    this.foreignCharge = privilegeUpdateData.row.foreign_charge / 100;
    this.processingTime = privilegeUpdateData.row.processing_time;
    this.transactionTypeId = privilegeUpdateData.row.transaction_type_id;
  },
  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = new FormData();
          data.append("application", "android");
          data.append("applicationVersion", "1.33");
          data.append("deviceId", "XXXXXXXXXXXXXXXXXXXXXXXX");
          data.append("deviceDetail", "android s4 etc");
          data.append("latitude", "");
          data.append("longitude", "");
          data.append("flag", "active");
          data.append("id", this.id);
          data.append("currencyPaymentMethodId", this.currencyPaymentMethodId);
          data.append("transactionTypeId", this.transactionTypeId);
          data.append("minLimit", this.minLimit * 100);
          data.append("maxLimit", this.maxLimit * 100);
          data.append("foreignCharge", this.foreignCharge * 100);
          data.append("processingTime", this.processingTime);

          this.makeRequest("post", "v1/update-privilege", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;

                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("privilege");
                    if (storeData != null) {
                      if (typeof storeData.firstPageData != "undefined") {
                        if (
                          typeof storeData.firstPageData.data[this.index] !=
                          "undefined"
                        ) {
                          if (
                            storeData.firstPageData.data[this.index].id ==
                            this.id
                          ) {
                            storeData.firstPageData.data[
                              this.index
                            ] = responseData;
                            delete storeData.otherPageData;
                          }
                        }
                      }
                      if (typeof storeData.otherPageData != "undefined") {
                        if (
                          typeof storeData.otherPageData.data[this.index] !=
                          "undefined"
                        ) {
                          if (
                            storeData.otherPageData.data[this.index].id ==
                            this.id
                          ) {
                            storeData.otherPageData.data[
                              this.index
                            ] = responseData;
                          }
                        }
                      }
                      storeData.key = "privilege";
                      this.$store.dispatch("set", storeData);
                    }
                    this.$router.push({
                      name: "privilege",
                      params: { update: true }
                    });
                  }
                } else {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

